export default "__VITE_ASSET__Q4nAdOdj__"